import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'PopoverMenuItem',
  props: {
    center: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["popover-menu-item", { 'center': _ctx.center }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})